export const SEO_PLACE_TYPE_OPTIONS = [
  { value: '', label: 'All types' },
  { value: 'airport', label: 'Airports' },
  { value: 'location', label: 'Locations' },
  { value: 'cruise_port', label: 'Cruise ports' },
] as const;

export type SeoPlaceRecord = {
  id: string;
  slug: string;
  placeType: string;
  name: string;
  fullName: string | null;
  iata: string | null;
  city: string | null;
  county: string | null;
  region: string | null;
  published: boolean;
  seo: {
    metaTitle: string;
    metaDescription: string;
    h1: string;
    intro: string;
    keywords: string[];
  };
};

export function placeTypeLabel(placeType: string): string {
  return (
    SEO_PLACE_TYPE_OPTIONS.find((opt) => opt.value === placeType)?.label ??
    placeType
  );
}
